//# sourceMappingURL=tag.mjs.map
/// <reference types="./tag.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $decrypt from "../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class Tag extends $CustomType {
  constructor(id, name, org_id) {
    super();
    this.id = id;
    this.name = name;
    this.org_id = org_id;
  }
}
export const Tag$Tag = (id, name, org_id) => new Tag(id, name, org_id);
export const Tag$isTag = (value) => value instanceof Tag;
export const Tag$Tag$id = (value) => value.id;
export const Tag$Tag$0 = (value) => value.id;
export const Tag$Tag$name = (value) => value.name;
export const Tag$Tag$1 = (value) => value.name;
export const Tag$Tag$org_id = (value) => value.org_id;
export const Tag$Tag$2 = (value) => value.org_id;

export function decoder() {
  return $decode.field(
    "id",
    $decrypt.uuid(),
    (id) => {
      return $decode.field(
        "name",
        $decode.string,
        (name) => {
          return $decode.field(
            "org_id",
            $decode.string,
            (org_id) => { return $decode.success(new Tag(id, name, org_id)); },
          );
        },
      );
    },
  );
}

export function encode(tag) {
  return $json.object(
    toList([
      ["id", $json.string(tag.id)],
      ["name", $json.string(tag.name)],
      ["org_id", $json.string(tag.org_id)],
    ]),
  );
}

export function compare(t1, t2) {
  return $string.compare(t1.name, t2.name);
}
